import styled from 'styled-components';
import { defaultBoldTextCss } from '../../common/mixins';

export const ButtonLink = styled.button.attrs(() => ({
  type: 'button'
}))`
  ${defaultBoldTextCss};

  color: ${({ theme }) => theme.colours.link.text};
  border: none;
  background-color: transparent;
  cursor: pointer;
  outline: none;
  :hover,
  :focus {
    text-decoration: underline;
  }
`;
